export default "__VITE_ASSET__CA$SUZ0k__"